import { useQueries } from "@tanstack/react-query";
import { useAuth } from "../context/AuthContext";
import { cardsDaV2, semFiltroDaV2 } from "../pages/revenue/kpisDaV2";
import useApiV2, {
  CINCO_MINUTOS,
  repetirSoErroDeServidor,
} from "../utils/useApiV2";

export default function useRevenueKpisV2({
  branchId,
  start,
  end,
  filtros,
  enabled = true,
}) {
  const {
    getRevenueMetrics,
    getDerivedMetrics,
    getConversionMetrics,
    getZoneAllocation,
  } = useApiV2();
  const { user } = useAuth();
  const ativo = Boolean(enabled && branchId && start && end);
  const base = { branch_id: branchId, start, end };
  const chave = [user?.user_id ?? null, branchId, start, end];
  const comRateio = semFiltroDaV2(filtros);

  const consulta = (nome, buscar, params, ligado = true) => ({
    queryKey: ["revenueKpisV2", nome, ...chave, params],
    queryFn: () => buscar(params),
    enabled: ativo && ligado,
    staleTime: CINCO_MINUTOS,
    retry: repetirSoErroDeServidor,
  });

  const [receita, derivadas, conversao, rateio] = useQueries({
    queries: [
      consulta("receita", getRevenueMetrics, { ...base, ...filtros }),
      consulta("derivadas", getDerivedMetrics, { ...base, ...filtros }),
      consulta("conversao", getConversionMetrics, {
        ...base,
        tipo: "presencial",
      }),
      consulta(
        "rateio",
        getZoneAllocation,
        { ...base, group_by: "none" },
        comRateio
      ),
    ],
  });

  const consultas = comRateio
    ? [receita, derivadas, conversao, rateio]
    : [receita, derivadas, conversao];
  const comErro = consultas.find((item) => item.isError);
  const prontas = consultas.every((item) => item.data);

  return {
    data: prontas
      ? cardsDaV2({
          receita: receita.data,
          derivadas: derivadas.data,
          conversao: conversao.data,
          rateio: comRateio ? rateio.data : null,
        })
      : undefined,
    isLoading: ativo && !prontas && !comErro,
    isError: Boolean(comErro),
    error: comErro?.error ?? null,
    produtosSemCategoria: receita.data?.produtos_sem_categoria ?? [],
  };
}
